import { AxiosClient } from "@/app/shared/services";

const state = {
    profile: {
        isLoading: false,
        isCreditScoreModalOpened: false,
        isAgatationModalOpened: false,
        isPaymentsModalOpened: false,
    },
    validation: {
        email: {
            isOpen: false,
        },
        password: {
            isOpen: false,
        },
    },
    notifications: {
        noCreditCard: false,
    },
};

const getters = {
    PROFILE_IS_LOADING: (state) => state.profile.isLoading,
    IS_EMAIL_VALIDATION_OPENED: (state) => state.validation.email.isOpen,
    IS_PASSWORD_MODAL_OPENED: (state) => state.validation.password.isOpen,
    IS_CREDIT_SCORE_MODAL_OPENED: (state) => state.profile.isCreditScoreModalOpened,
    IS_AGITATION_MODAL_OPENED: (state) => state.profile.isAgatationModalOpened,
    IS_PAYMENTS_MODAL_OPENED: (state) => state.profile.isPaymentsModalOpened,
    OPENED_NOTIFICATIONS: (state) => state.notifications,
};

const mutations = {
    SET_PROFILE_IS_LOADING: (state, isLoading) => {
        state.profile.isLoading = isLoading;
    },
    SET_EMAIL_VALIDATION_IS_OPENED: (state, isOpen) => (state.validation.email.isOpen = isOpen),
    SET_PASSWORD_MODAL_IS_OPENED: (state, isOpen) => (state.validation.password.isOpen = isOpen),
    SET_CREDIT_SCORE_MODAL_IS_OPENED: (state, isOpen) =>
        (state.profile.isCreditScoreModalOpened = isOpen),
    SET_AGITATION_MODAL_IS_OPENED: (state, isOpen) =>
        (state.profile.isAgatationModalOpened = isOpen),
    SET_PAYMENTS_MODAL_OPENED: (state, isOpen) => (state.profile.isPaymentsModalOpened = isOpen),
    SET_OPENED_NOTIFICATIONS: (state, { notification, isOpened }) => {
        if (state.notifications.hasOwnProperty(notification))
            state.notifications[notification] = isOpened;
    },
};

const actions = {
    CHANGE_USER_PASSWORD: (context, password) => {
        context.commit("SET_PROFILE_IS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post("/profile/change_password", { password })
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_PROFILE_IS_LOADING", false);
                });
        });
    },

    CHANGE_USER_PROFILE_DATA: (context, user) => {
        context.commit("SET_PROFILE_IS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post("/profile/update", user)
                .then((data) => {
                    context.commit("SET_AUTH_USER", data.data.user);
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_PROFILE_IS_LOADING", false);
                });
        });
    },

    CHANGE_VERIFICATE_USER_EMAIL: (context, user) => {
        context.commit("SET_PROFILE_IS_LOADING", true);
        return new Promise((resolve, reject) => {
            const params = {
                uuid: user.uuid,
                email: user.email,
            };
            AxiosClient.post("/profile/send_verification_email_for_changing", params)
                .then((data) => {
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_PROFILE_IS_LOADING", false);
                });
        });
    },

    SET_DEVICE_IDENTIFICATOR: (context, token) => {
        if (localStorage.getItem("deviceToken") != token) {
            return new Promise((resolve, reject) => {
                const platform = process.env.VUE_PLATFORM ? process.env.VUE_PLATFORM : "web";
                AxiosClient.post("/profile/store_device", {
                    platform,
                    identificator: token,
                    application: context.rootState.app_settings.settings.fcm_key_name,
                })
                    .then(() => {
                        resolve();
                        localStorage.setItem("deviceToken", token);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }
        return Promise.resolve();
    },

    EMAIL_VALIDATION: (context, isOpen) => {
        context.commit("SET_EMAIL_VALIDATION_IS_OPENED", isOpen);
    },

    CHANGE_PASSWORD_MODAL: (context, isOpen) => {
        context.commit("SET_PASSWORD_MODAL_IS_OPENED", isOpen);
    },

    SET_USER_CREDIT_SCORE: (context, score) => {
        return new Promise((resolve, reject) => {
            context.commit("SET_PROFILE_IS_LOADING", true);
            AxiosClient.post("/profile/set_credit_score", { score })
                .then(() => {
                    context.commit("SET_PROFILE_CREDIT_SCORE", score, { root: true });
                    resolve();
                })
                .catch(() => reject())
                .finally(() => context.commit("SET_PROFILE_IS_LOADING", false));
        });
    },

    OPEN_CREDIT_SCORE_MODAL: (context, isOpen) => {
        context.commit("SET_CREDIT_SCORE_MODAL_IS_OPENED", isOpen);
    },

    OPEN_AGITATION_MODAL: (context, isOpen) => {
        context.commit("SET_AGITATION_MODAL_IS_OPENED", isOpen);
    },

    UPDATE_USER_APP_RATING: (context, app_rating) => {
        return new Promise((resolve, reject) => {
            AxiosClient.post("/profile/set_app_rating", { app_rating })
                .then(() => {
                    context.commit("SET_PROFILE_APP_RATING", app_rating, { root: true });
                    resolve();
                })
                .catch(() => reject())
                .finally(() => {});
        });
    },
    OPEN_PAYMENTS_MODAL: (context, isOpen) => {
        context.commit("SET_PAYMENTS_MODAL_OPENED", isOpen);
    },

    SET_USER_TEST_GROUP: (context, group) => {
        return AxiosClient.post("/profile/set-user-group", { group });
    },

    SET_OPENED_NOTIFICATIONS: (context, { notification, isOpened }) => {
        context.commit("SET_OPENED_NOTIFICATIONS", { notification, isOpened });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
